// src/hooks/usePrevious.js

import { useEffect, useRef } from 'react';

/**
 * Custom Hook to store the previous value of a prop or state
 * @param {*} value - The current value to track
 * @returns {*} The previous value
 */
const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value; // Update ref with the current value after each render
  }, [value]); // Re-run the effect only if the value changes

  return ref.current; // Return the previous value (before the update)
};

export default usePrevious;
